import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import bannerImage from "../../Images/about/Artboard-1.webp";
import classroomImage from "../../Images/gov-body/rules.webp";
import { Row } from "react-bootstrap";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import "../../Placement.css";
import acc from "../../Images/accrediations/Naac.webp"

const NAAC = () => {
    const schemaData = {
        "@context": "https://schema.org",
        "@type": "CollegeOrUniversity",
        "@id": "https://isbmuniversity.edu.in/",
        "name": "ISBM University Chhattisgarh",
        "foundingDate": "2016",
        "description":
            "ISBM University, Chhattisgarh offers UGC-approved UG, PG & PhD programs. Recognized as a top university for quality education & career success.",
        "logo":
            "https://www.isbmuniversity.ac.in/assets/Images/logo/isbm-university.png",
        "sameAs": [
            "https://www.facebook.com/isbmuniversity/",
            "https://instagram.com/isbm_university",
            "https://twitter.com/ISBMUniversity",
            "https://www.linkedin.com/school/13211303/",
            "https://www.youtube.com/c/ISBMUniversity"
        ],
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "ISBM University, Ring Road No. 1",
            "addressLocality": "Tatibandh, Raipur",
            "addressRegion": "Chhattisgarh",
            "postalCode": "492099",
            "addressCountry": "IN"
        },
        "telephone": "+91-9373199999",
        "email": "info@isbmuniversity.edu.in",
        "contactPoint": [
            {
                "@type": "ContactPoint",
                "contactType": "Admissions",
                "telephone": "+91-9373199999",
                "email": "enquiry@isbmuniversity.edu.in",
                "availableLanguage": ["en", "hi"]
            }
        ],
        "department": [
            {
                "@type": "EducationalOrganization",
                "name": "ISBM University Chhattisgarh",
                "url": "https://isbmuniversity.edu.in/"
            }
        ],
        "knowsAbout": [
            "Management",
            "Engineering",
            "Commerce",
            "Law",
            "Science",
            "Arts & Humanities",
            "Pharmacy",
            "Library & Information Science",
            "NAAC Accreditation",
            "Ph.D. Research"
        ],
        "areaServed": {
            "@type": "Country",
            "name": "India"
        },
        "potentialAction": {
            "@type": "ApplyAction",
            "name": "Apply Online",
            "target": "https://isbmuniversity.edu.in/apply-online"
        }
    };

    useEffect(() => {
        // Title
        document.title = "ISBM University NAAC Accreditation |  Grade Recognition";

        // Canonical link
        // let link = document.querySelector("link[rel='canonical']");
        // if (!link) {
        //     link = document.createElement("link");
        //     link.setAttribute("rel", "canonical");
        //     document.head.appendChild(link);
        // }
        // link.setAttribute("href", "https://isbmuniversity.edu.in");

        // Schema script
        let script = document.querySelector("script[data-schema='true']");
        if (script) {
            script.innerHTML = JSON.stringify(schemaData);
        } else {
            script = document.createElement("script");
            script.setAttribute("type", "application/ld+json");
            script.setAttribute("data-schema", "true");
            script.innerHTML = JSON.stringify(schemaData);
            document.head.appendChild(script);
        }
    }, []);
    return (
        <>
            <title> ISBM University NAAC Accreditation |  Grade Recognition</title>
            <meta
                name="description"
                content="ISBM University, Chhattisgarh, is NAAC-accredited. Explore official recognition, quality standards, and accreditation details."
            />

            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="conatiner-xxl">
                        <div className="section-hero-content">
                            <h1>National Assessment And Accereditation Council</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </a>
                                </li>
                                <li
                                    className="breadcrumb-item active text-white"
                                    aria-current="page"
                                >
                                    NAAC
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section class="ptb-50">
                <div class="container-xxl">
                    <h2 class="section-title modern-title text-center text-blue">NAAC Accreditation – A Symbol of Academic Excellence</h2>
                    <p class="text-center mx-auto">Quality education and continuous improvement as per national standards.</p>

                    <div class="row g-4">
                        <div class="col-12">
                            <div class="modern-health">
                                <div class="row g-0 h-100 mt-5">
                                    <div class="col-md-6 order-md-1 position-relative">
                                        <div class="health-image-container">
                                            <div class="health-background-block bg-purple"></div>
                                            <img src={acc} alt="Sports Activities" class="health-image" />
                                        </div>
                                    </div>
                                    <div class="col-md-6 order-md-2">
                                        <p>ISBM University adheres to the highest standards of quality as outlined by the National Assessment and Accreditation Council (NAAC). This accreditation reflects our commitment to excellence in education, innovation, and holistic student development.</p>
                                        <p>We focus on providing value-based learning, outcome-driven programs, and an industry-oriented curriculum, ensuring that students are equipped with the skills and knowledge needed for global success.
                                        </p>
                                        <h3 class="fw-bold mb-3">Key Highlights of NAAC Accreditation</h3>

                                        <div class="health-highlights mb-3">
                                            <div class="health-highlight-item">
                                                <i class="ti ti-check"></i> Assurance of high academic and institutional quality.
                                            </div>
                                            <div class="health-highlight-item">
                                                <i class="ti ti-check"></i> Industry-aligned curriculum and pedagogy.
                                            </div>
                                            <div class="health-highlight-item">
                                                <i class="ti ti-check"></i> Student-centric teaching and learning environment.
                                            </div>
                                            <div class="health-highlight-item">
                                                <i class="ti ti-check"></i> Commitment to research, innovation, and global standards.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
            <Footer />
        </>
    );
};

export default NAAC;
